import * as Immutable from 'immutable';
import * as React from 'react';

import { Link } from 'react-router-dom';

import { localeData } from '../../../locales/data';
import { ResultsProps } from '../../../reducers/LearnReducer/SearchReducer/SearchReducer.types';
import { Pagination } from '../../Pagination/Pagination';
import { PaginationResults } from '../../Pagination/PaginationResults';

import './SearchResults.scss';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';
import { getThumbnailUrl } from '../../Box/Box';

interface SearchResultsVideoProps {
  data: Immutable.List<ResultsProps>;
  title: string;
  queryTerm: string;
  count: number;
  changePrevPage: () => void;
  changeNextPage: () => void;
  getPaginationNumbers: () => any[];
  changePage: (val: number) => void;
  pageSize: number;
  // The pathname where the current Learn Component it is been displayed
  // Eg : in this route /simulate the value is simulate, for the route /learn the value is learn
  path: string;
  page: number;
  pages: number;
  showPagination: boolean;
}

export const SearchResultsVideo = ({
  data,
  title,
  queryTerm,
  count,
  changePrevPage,
  changeNextPage,
  getPaginationNumbers,
  changePage,
  pageSize,
  path,
  page,
  pages,
  showPagination,
}: SearchResultsVideoProps) => {
  const ResultsPagination = Pagination(PaginationResults);
  const dataSize = data ? data.size : 0;

  return (
    <div className="search-results">
      <h2 className="search-results__main-title search-results__main-title--video-course">
        {title} [{dataSize}]
      </h2>

      {dataSize !== 0 ? (
        <div>
          <div className="card-element__grid">
            {data.map((item: any, index: number) => (
              <div className="card-element__item" key={`${item.get('id')}-${index}`}>
                <div className="search-results__video-thumb">
                  <Link to={`/${path}/courses/${item.get('videoCourse')}/${item.get('id')}`}>
                    <img className="box__video" src={getThumbnailUrl({ source: item.get('source'), videoId: item.get('uid') })} />
                  </Link>
                </div>

                {item.get('title') && item.get('id') ? (
                  <h3 className="search-results__title search-results__title--video">
                    <Link to={`/${path}/courses/${item.get('videoCourse')}/${item.get('id')}`}>{item.get('title')}</Link>
                  </h3>
                ) : null}

                <div className="search-results__video-lesson">
                  <FormattedMessageHelper
                    tagName="span"
                    id="learn.search.video.lesson"
                    defaultMessage={localeData.en['learn.search.video.lesson']}
                    values={{ lesson: item.get('sequence') }}
                  />
                  {item.get('category') ? (
                    <span>
                      <FormattedMessageHelper tagName="span" id="learn.search.of" defaultMessage={localeData.en['learn.search.of']} />
                      <Link className="search-results__video-cat" to={`/${path}/courses/${item.get('videoCourse')}`}>
                        {item.get('category')}
                      </Link>
                    </span>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
          <div className="search-results__pagination">
            <ResultsPagination
              pageSize={pageSize}
              numOfResults={count}
              changePrevPage={changePrevPage}
              changeNextPage={changeNextPage}
              getPaginationNumbers={getPaginationNumbers}
              page={page}
              changePage={changePage}
              pages={pages}
              extraInfo={{ msg: 'pagination.show.results.related', values: { value: title.toLocaleLowerCase() } }}
              showPagination={showPagination}
            />
          </div>
        </div>
      ) : (
        <div className="search-results__no-results">
          <FormattedMessageHelper
            tagName="span"
            id="learn.search.no.results"
            defaultMessage={localeData.en['learn.search.no.results']}
            values={{ term: queryTerm }}
          />
        </div>
      )}
    </div>
  );
};
